import Vue from 'vue';
import Vuex from 'vuex';
import globals from './modules/globals';
import {parseJwt} from "../services/jwt.service";
import ApiService from "../services/api.service";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: null,
    currentDealership: null,
    currentPriority: null,
    currentBenchmarks: null,
    currentAssessment: null,
    scs: null
  },
  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user;
    },
    setCurrentDealership(state, dealership) {
      state.currentDealership = dealership;
    },
    setCurrentPriority(state, priority) {
      state.currentPriority = priority;
    },
    setCurrentBenchmarks(state, benchmarks) {
      state.currentBenchmarks = benchmarks;
    },
    setCurrentAssessment(state, assessment) {
      state.currentAssessment = assessment;
    },
    setSCS(state, scs) {
      state.scs = scs
    },
  },
  actions: {
    getCurrentUser({ commit }) {
      const token = parseJwt();
      if (token && Object.prototype.hasOwnProperty.call(token, 'sub')) {
        return ApiService.get('api/v1/users', token.sub)
          .then(({ data }) => {
            commit('setCurrentUser', data);
            return data;
          });
      }
      return null;
    },
  },
  modules: {
    globals,
  },
  strict: process.env.NODE_ENV !== 'production',
});
